// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__7K1Be","wrapper":"Modal_wrapper__cvAeW"};